import { SVGAttributes } from 'react';

type Props = SVGAttributes<SVGElement>;

export function IconFlip360Reversed(props: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            data-testid="IconFlip360Reversed"
            {...props}
        >
            <path d="M9 19L7.6 17.6L9.35 15.8C7.21667 15.5167 5.45833 14.9333 4.075 14.05C2.69167 13.1667 2 12.15 2 11C2 9.61667 2.9625 8.4375 4.8875 7.4625C6.8125 6.4875 9.18333 6 12 6C14.8167 6 17.1875 6.4875 19.1125 7.4625C21.0375 8.4375 22 9.61667 22 11C22 12.0333 21.4458 12.9583 20.3375 13.775C19.2292 14.5917 17.7833 15.2 16 15.6V13.55C17.2833 13.2167 18.2708 12.8042 18.9625 12.3125C19.6542 11.8208 20 11.3833 20 11C20 10.4667 19.2875 9.83333 17.8625 9.1C16.4375 8.36667 14.4833 8 12 8C9.51667 8 7.5625 8.36667 6.1375 9.1C4.7125 9.83333 4 10.4667 4 11C4 11.4 4.425 11.8792 5.275 12.4375C6.125 12.9958 7.33333 13.4167 8.9 13.7L7.6 12.4L9 11L13 15L9 19Z" />
        </svg>
    );
}
